import React, { useEffect } from "react";
import FineRegistration from "../Pages/Community/FineRegistration";
import Latestupdate from "../Component/Latestupdate/Latestupdate";
import Community from "../Pages/Community/Community";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import { useSelector } from "react-redux";

export default function Communitytheme() {

  return (
    <>
      {/* <Header /> */}
      {/* <Community /> */}
      <FineRegistration />
      {/* <Latestupdate />
      <Footer /> */}
    </>
  );
}
